// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TimeSpanPeriods } from '../Time/TimeSpan';
export class CashItemUtils {
    static FindStartData(time, newPeriod, sessionBeginOffset) {
        sessionBeginOffset = sessionBeginOffset || 0;
        const data = time.getTime() - new Date(1970, 1, 1).getTime() - sessionBeginOffset;
        const periodsCount = data / (newPeriod * TimeSpanPeriods.TicksPerSecond * 60);
        const trunc = periodsCount - Math.trunc(periodsCount);
        let dx = trunc * newPeriod; // разница по времени между началом бара и указанной точкой
        if (dx < 0.99)
            dx = 0; // заплатка на случй мерджа данных из тиков, когда время тика = N минут 31 и более секунд. тогда округление приведет к тому, что будет вставлена лишняя минута
        const minutesToAdd = Math.round(dx); // тут раунд, а не транк, так как есть вариант, что получим 13.9999 минут для вставки вместо 14
        // если смещение меньше базового периода, т.е. минимальной величины, добавлять ничего не надо
        // заплатка для приколов со сменой стартдей дневной истории
        // if (Math.Abs(newPeriod - minutesToAdd) >= basePeriod)
        time = new Date(time.setMinutes(time.getMinutes() - minutesToAdd));
        // else
        // {
        // }
        return time;
    }
}
export var PriceType;
(function (PriceType) {
    /// <summary>
    /// Цена открытия
    /// </summary>
    PriceType[PriceType["Open"] = 0] = "Open";
    /// <summary>
    /// Цена закрытия
    /// </summary>
    PriceType[PriceType["Close"] = 1] = "Close";
    /// <summary>
    /// Максимальная цена
    /// </summary>
    PriceType[PriceType["High"] = 2] = "High";
    /// <summary>
    /// Минимальная цена
    /// </summary>
    PriceType[PriceType["Low"] = 3] = "Low";
    /// <summary>
    /// Средняя цена
    /// </summary>
    PriceType[PriceType["Medium"] = 4] = "Medium";
    /// <summary>
    /// Типичная цена
    /// </summary>
    PriceType[PriceType["Typical"] = 5] = "Typical";
    /// <summary>
    /// Средневзвешенная цена
    /// </summary>
    PriceType[PriceType["Weighted"] = 6] = "Weighted";
})(PriceType || (PriceType = {}));
export function getPriceTypeKey(value) {
    switch (value) {
        case PriceType.Open:
            return 'property.Open';
        case PriceType.Close:
            return 'property.Close';
        case PriceType.High:
            return 'property.High';
        case PriceType.Low:
            return 'property.Low';
        case PriceType.Typical:
            return 'property.Typical';
        case PriceType.Medium:
            return 'property.Medium';
        case PriceType.Weighted:
            return 'property.Weighted';
        default:
            return '';
    }
}
export const PriceTypeMap = Object.fromEntries(Object.entries(PriceType).map(([k, v]) => [v, k]));
Object.freeze(PriceTypeMap);
